import { PersonalDetailsFormSubmitType } from '@common/util-models';
import { createAction, props } from '@ngrx/store';

export const setPersonalDetails = createAction(
  '[Common] Set Personal Details',
  props<{ payload: Partial<Omit<PersonalDetailsFormSubmitType, 'payment'>> }>()
);
